/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFolderViewOnly = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M2 2h8.618l2 4H22v8h-2V8h-8.618l-2-4H4v16h6v2H2zm15.5 18.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5z" />
        <path d="M22.894 18.553C21.736 16.236 19.654 15 17.5 15s-4.236 1.236-5.394 3.553l-.224.447.224.447C13.264 21.764 15.346 23 17.5 23s4.236-1.236 5.394-3.553l.224-.447zM17.5 21c-1.221 0-2.5-.628-3.356-2 .856-1.372 2.135-2 3.356-2s2.5.628 3.356 2C20 20.372 18.72 21 17.5 21z" />
      </g>
    </g>
  </Icon>
);
export { SvgFolderViewOnly as FolderViewOnly };
